import { UNDO_NAMESPACE_SYMBOL } from '../constants';

/**
 * THIS RETURNS A FUNCTION YOU MUST CALL IT AS A FUNCTION OR YOU WILL HAVE WEIRD BUGS
 *
 * Use this decorator on any action that can be undone and/or that needs to be saved
 *
 * Note: This decorator needs to come before the actionCreator decorator because the actionCreator decorator uses the name of the function
 * it wraps to generate the action type, therefore it cannot wrap this function but must wrap the action function itself
 *
 * @param {string|symbol} [recordingGroup] - The optional recording group this recording is part of
 */
const recordForUndo = (recordingGroup) => {
  return (target, name, descriptor) => {
    const original = descriptor.value;

    // Add the shouldRecordForUndo flag and optional the recordingGroup to the action returned
    // These flags will be used by the recordForUndo middleware which is added to the store in createStore.js
    const wrapperFunction = (...args) => {
      const actionObjectLiteral = original.apply(target, args) || {};
      actionObjectLiteral[UNDO_NAMESPACE_SYMBOL] = {
        shouldRecordForUndo: true,
      };

      if (recordingGroup) {
        actionObjectLiteral[
          UNDO_NAMESPACE_SYMBOL
        ].recordingGroup = recordingGroup;
      }
      return actionObjectLiteral;
    };

    // This type is assigned in the actionCreator decorator and were essentially passing it through this decorator
    wrapperFunction.TYPE = descriptor.value.TYPE;
    wrapperFunction.toString = () => wrapperFunction.TYPE;

    descriptor.value = wrapperFunction;
    return descriptor;
  };
};

export default recordForUndo;
